import {
  UPDATE_FIELD,
  SET_CONFIG,
  RESET_CONFIG,
  RESET_FILES,
  UPDATE_FILE
} from "../../constants/reduxActionTypes";

const initialState = {
  config: {
    active: false,
    // Print settings
    printable: false,

    // App customization
    cover: "",
    theme: "DARK",

    // Share settings
    appId: "",
    appSecret: "",
    facebookToken: "",
    pageId: "",
    templateId: ""
  },
  files: {}
};
function configReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_FIELD: {
      return Object.assign({}, state, {
        config: {
          ...state.config,
          ...action.payload
        }
      });
    }
    case UPDATE_FILE: {
      return Object.assign({}, state, {
        files: {
          ...state.files,
          ...action.payload
        }
      });
    }
    case SET_CONFIG: {
      const { config } = action.payload;

      // booleans are received as strings so they need to be converted
      const items = Object.keys(config);
      for (let i = 0; i < items.length; i += 1) {
        if (config[items[i]] != null) {
          switch (config[items[i]]) {
            case "true":
              config[items[i]] = true;
              break;
            case "false":
              config[items[i]] = false;
              break;
            default:
              break;
          }
        }
      }
      return Object.assign({}, state, {
        config
      });
    }
    case RESET_CONFIG: {
      return Object.assign({}, state, {
        config: initialState.config
      });
    }
    case RESET_FILES: {
      const newState = Object.assign({}, state, {
        files: initialState.files
      });
      return newState;
    }
    default:
      return state;
  }
}
export default configReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/configReducer.js